export default "__VITE_ASSET__0l8CU4kL__"